import { Component } from "react";

import HeaderRouteName from "../components/HeaderRouteName";

export default class ConfirmationInitiation extends Component {
  render() {
    return (
      <div className="border-bottom white-bg dashboard-header">
        <HeaderRouteName nestedRouteNames={["Initiation"]} />
      </div>
    );
  }
}
